var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:cloud-upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4587 20.8334H6.77116C5.1913 20.8334 3.8413 20.2865 2.72116 19.1928C1.60102 18.099 1.0413 16.7622 1.04199 15.1824C1.04199 13.8282 1.44998 12.6216 2.26595 11.5626C3.08192 10.5036 4.14963 9.82647 5.46908 9.53133C5.9031 7.93411 6.77116 6.64071 8.07324 5.65112C9.37533 4.66154 10.851 4.16675 12.5003 4.16675C14.5316 4.16675 16.2548 4.87439 17.6701 6.28966C19.0854 7.70494 19.7927 9.42786 19.792 11.4584C20.9899 11.5973 21.984 12.114 22.7743 13.0084C23.5646 13.9029 23.9594 14.9487 23.9587 16.1459C23.9587 17.448 23.5028 18.5549 22.591 19.4667C21.6791 20.3786 20.5725 20.8341 19.2712 20.8334H13.542V13.3855L15.2087 15.0001L16.667 13.5417L12.5003 9.37508L8.33366 13.5417L9.79199 15.0001L11.4587 13.3855V20.8334Z",
    fill: "#545454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.3c4f20ed950d078ba08986efff6e2bd4.svg";
export { ForwardRef as ReactComponent };